import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/external_link.svg'


const _withScopeId = n => (_pushScopeId("data-v-4aaecbf3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "result-next" }, "❯ ", -1))
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("span", null, "swimstats.net"),
  /*#__PURE__*/_createElementVNode("span", { class: "result-next" }, [
    /*#__PURE__*/_createElementVNode("img", {
      style: {"padding-left":"5px"},
      src: _imports_0,
      width: "12",
      height: "12"
    })
  ])
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("span", null, "swimrankings.net"),
  /*#__PURE__*/_createElementVNode("span", { class: "result-next" }, [
    /*#__PURE__*/_createElementVNode("img", {
      style: {"padding-left":"5px"},
      src: _imports_0,
      width: "12",
      height: "12"
    })
  ])
], -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_athletes_table = _resolveComponent("athletes-table")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_pull_refresh = _resolveComponent("pull-refresh")!

  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createVNode(_component_pull_refresh, {
      modelValue: _ctx.isLoading,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      onRefresh: _ctx.onRefresh,
      "pulling-text": "",
      "loosing-text": "update...",
      "loading-text": "fetch...",
      "success-text": "fetching.."
    }, {
      default: _withCtx(() => [
        (_ctx.athletesFocus.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_athletes_table, {
                athletess: _ctx.athletesFocus,
                athleteid: _ctx.athleteid,
                meetid: _ctx.meetid
              }, null, 8, ["athletess", "athleteid", "meetid"]),
              _createVNode(_component_router_link, {
                to: {
            name: 'Club',
            params: {
              clubid: _ctx.get_club_id_from_athlete_id(String(_ctx.$route.params.athleteid)),
              meetid: _ctx.$route.params.meetid,
              athleteid: 0,
              eventid: 0,
            },
          }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h3", null, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.get_clubname_from_club_id(
                  _ctx.get_club_id_from_athlete_id(String(_ctx.$route.params.athleteid))
                )), 1),
                    _hoisted_2
                  ])
                ]),
                _: 1
              }, 8, ["to"]),
              (_ctx.athletesFocus[0].swrid)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("a", {
                      href: 
              'https://www.swimstats.net/single?athlete1=' +
              _ctx.athletesFocus[0].fullname +
              ', ID:' +
              _ctx.athletesFocus[0].swrid
            
                    }, _hoisted_5, 8, _hoisted_3),
                    _createElementVNode("a", {
                      href: 
              'https://www.swimrankings.net/index.php?page=athleteDetail&athleteId=' +
              _ctx.athletesFocus[0].swrid
            
                    }, _hoisted_8, 8, _hoisted_6)
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"])
  ]))
}